import React from 'react'
import classes from 'classnames'
import Person from '../../components/Person'

export default ({ items = [], title, withPadding, isComplete = false, className = 'Main__auction', button = null, btnTitle, noTime = false, listName }) => {
  return (!items.length) ? null : (
  <section className={className}>
    {title && <h1 className='SubHead SubHead_extra-bottom-space'>{title}</h1>}
    <div className={classes('Main__lots-list', { 'Main__lots-list_no-pading': !withPadding, 'Main__lots-list_complete': isComplete })}>
      {items.map((item, i) => (
        <div key={`single-lots-${i}`} className='Main__lots-item_complete'>
          <Person data={item} isSingle isComplete={isComplete} noTime={noTime} position={i + 1} listName={listName}/>
          {button && <button className='Button Button_black Button_left-offset' onClick={button.bind(this, item._id)}>{btnTitle}</button>}
        </div>
      ))}
    </div>
  </section>
)
      }


// WEBPACK FOOTER //
// ./src/containers/LotList/singleList.jsx